import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const CourseManagement = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    // TODO: Implement course data fetching
    const fetchCourses = async () => {
      try {
        setLoading(true);
        // const data = await courseService.getCourses();
        // setCourses(data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch courses. Please try again later.');
        console.error('Error fetching courses:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
        <p>Loading courses...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <div className="error-content">
          <i className="error-icon fas fa-exclamation-circle"></i>
          <h2>Error Loading Courses</h2>
          <p>{error}</p>
          <button className="retry-button" onClick={() => window.location.reload()}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Course Management</h1>
        <button className="btn btn-primary">
          <i className="fas fa-plus"></i> Create New Course
        </button>
      </div>

      <div className="dashboard-content">
        <div className="filters-section">
          <div className="search-box">
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search courses..." />
          </div>
          <div className="filter-options">
            <select defaultValue="">
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="draft">Draft</option>
              <option value="archived">Archived</option>
            </select>
            <select defaultValue="">
              <option value="">All Categories</option>
              <option value="programming">Programming</option>
              <option value="design">Design</option>
              <option value="business">Business</option>
            </select>
          </div>
        </div>

        <div className="courses-grid">
          {courses.length === 0 ? (
            <div className="no-data">
              <i className="fas fa-book"></i>
              <h2>No Courses Found</h2>
              <p>Start by creating your first course</p>
            </div>
          ) : (
            courses.map(course => (
              <div key={course.id} className="course-card">
                <div className="course-header">
                  <h3>{course.title}</h3>
                  <div className="course-actions">
                    <button className="action-btn edit">
                      <i className="fas fa-edit"></i>
                    </button>
                    <button className="action-btn more">
                      <i className="fas fa-ellipsis-v"></i>
                    </button>
                  </div>
                </div>
                <div className="course-stats">
                  <p>
                    <i className="fas fa-users"></i>
                    {course.students} Students
                  </p>
                  <div className="progress-container">
                    <div className="progress-bar">
                      <div 
                        className="progress" 
                        style={{ width: `${course.progress}%` }}
                      ></div>
                    </div>
                    <span className="progress-text">{course.progress}% Complete</span>
                  </div>
                </div>
                <div className="course-footer">
                  <span className={`status-badge ${course.status.toLowerCase()}`}>
                    {course.status}
                  </span>
                  <button className="view-details-btn">
                    View Details
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseManagement; 